import { render } from "./Wait.vue?vue&type=template&id=4ba5d3fc&scoped=true"
import script from "./Wait.vue?vue&type=script&lang=js"
export * from "./Wait.vue?vue&type=script&lang=js"

import "./Wait.vue?vue&type=style&index=0&id=4ba5d3fc&scoped=true&lang=css"

import exportComponent from "/home/lucas/projects/distrisuper/pc-21/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba5d3fc"]])

export default __exports__